import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client'

class ReferralPageTrack extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'ReferralPageTrack'
  // Define default properties here
  static instanceDefaults() {
    return {
    }
  }
}
const servicePath = 'referral/page-track'
const servicePlugin = makeServicePlugin({
  Model: ReferralPageTrack,
  service: feathersClient.service(servicePath),
  servicePath,
  namespace: 'referral-page-track'
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin